import React, { useEffect, useState } from 'react'
import CMS from '../../components/cms/CMS'
import PageBanner from '../../components/general/PageBanner'
import { useTranslation } from 'react-i18next'
import CMSTable from '../../components/general/CMSTable'
import { columns } from '../../utilities/columns/documentColumns'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import CrudDocument from './CrudDocument'
import { fetchDocumentDelete } from '../../redux/slices/documentDeleteSlice'
import { fetchDocumentGetAll } from '../../redux/slices/documentGetAllSlice'

const DocumentPage = () => {
    const { t } = useTranslation()
    const [modal, setModal] = useState(false)
    const [selectedItem, setSelectedItem] = useState(0)
    const [changed, setChanged] = useState(false)
    const lang = useSelector((state) => state.lang.lang)
    const documents = useSelector((state) => state.documentGetAll.data)
    const navigation = useNavigate()
    const dispatch = useDispatch()

    const getData = async () => {
        await dispatch(fetchDocumentGetAll())
    }

    const deleteData = async (id) => {
        await dispatch(fetchDocumentDelete({ id: id }))
        setChanged(true)
        getData()
    }

    useEffect(() => { getData() }, [dispatch, changed])

    return (
        <CMS>
            <PageBanner
                title={t("document_management")}
                description={t("document_management_desc")}
                buttonText={t("add_document")}
                modal={modal}
                setModal={setModal}
            />

            <CMSTable
                columns={columns({
                    t: t,
                    modal: modal,
                    setModal: setModal,
                    lang: lang,
                    deleteData: deleteData,
                    navigation: navigation,
                    setSelectedItem: setSelectedItem
                })}
                data={documents}
            />

            <CrudDocument
                showMenu={modal}
                setShowMenu={setModal}
                setChanged={setChanged}
                setSelectedItem={setSelectedItem}
                selectedItem={selectedItem}
                t={t}
            />
        </CMS>
    )
}

export default DocumentPage
